import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const CustomerDashboard = () => {
  const [serviceDetailsMap, setServiceDetailsMap] = useState({});
  // Fetch all service details and build a map of id to name
  useEffect(() => {
    fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/service_details/all`)
      .then(res => res.json())
      .then(data => {
        // Build a map: id -> name
        const map = {};
        if (Array.isArray(data)) {
          data.forEach(detail => {
            map[detail.id] = detail.name;
          });
        }
        setServiceDetailsMap(map);
      });
  }, []);
  const [appointments, setAppointments] = useState([]);
  const [ratings, setRatings] = useState([]);
  // const [invoices, setInvoices] = useState([]);
  const [vendorNames, setVendorNames] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Get user_id from logged in user
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const user_id = user.id;

  useEffect(() => {
    if (!user_id) return;
    Promise.all([
  fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/customer_appointments?user_id=${user_id}`).then(res => res.json()),
  fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/customer_ratings?customer_id=${user_id}`).then(res => res.json())
  // fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/invoices?customer_id=${user_id}`).then(res => res.json())
    ]).then(([appointmentsData, ratingsData, invoicesData]) => {
      setAppointments(appointmentsData.appointments || []);
      setRatings(ratingsData.ratings || []);
      // setInvoices(invoicesData.invoices || []);
      setLoading(false);
    });
  }, [user_id]);

  // Fetch vendor names for appointments
  useEffect(() => {
    const fetchVendorNames = async () => {
      const namesMap = {};
      for (const app of appointments) {
        if (app.vendor_id && !namesMap[app.vendor_id]) {
          try {
            const res = await fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/vendor?vendor_id=${app.vendor_id}`);
            const data = await res.json();
            if (data.vendor) {
              namesMap[app.vendor_id] = `${data.vendor.firstName} ${data.vendor.lastName}`;
            }
          } catch {
            namesMap[app.vendor_id] = 'Unknown Vendor';
          }
        }
      }
      setVendorNames(namesMap);
    };
    if (appointments.length > 0) fetchVendorNames();
  }, [appointments]);

  if (loading) return <div style={styles.container}>Loading dashboard...</div>;

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Customer Dashboard</h2>
      <div style={styles.cardGrid}>
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>Appointments</h3>
          {appointments.length === 0 ? (
            <div style={styles.empty}>No appointments found.</div>
          ) : (
            <>
              <ul style={styles.list}>
                {appointments
                  .filter(app => app.status !== 'completed')
                  .sort((a, b) => new Date(b.creation_date) - new Date(a.creation_date))
                  .slice(0, 5)
                  .map(app => (
                    <li key={app.id} style={styles.listItem}>
                      <div>
                        <strong>Vendor:</strong> {vendorNames[app.vendor_id] || 'Loading...'}
                        <br />
                        <strong>Date:</strong>{' '}
                        {app.date
                          ? (() => {
                              const d = new Date(app.date);
                              const mm = String(d.getMonth() + 1).padStart(2, '0');
                              const dd = String(d.getDate()).padStart(2, '0');
                              const yyyy = d.getFullYear();
                              return `${mm}/${dd}/${yyyy}`;
                            })()
                          : ''}
                        <br />
                        <strong>Start Time:</strong> {app.start_time}
                        <br />
                        <strong>End Time:</strong> {app.end_time}
                        <br />
                        <strong>Subject:</strong> {serviceDetailsMap[app.product_detail_id] || app.product_detail_id || 'N/A'}
                        <br />
                        <strong>Status:</strong>{' '}
                        <span
                          style={{
                            color:
                              app.status === 'pending'
                                ? '#ff9800'
                                : app.status === 'accepted'
                                ? '#388e3c'
                                : app.status === 'rejected'
                                ? '#d32f2f'
                                : '#333',
                            fontWeight: 'bold',
                          }}
                        >
                          {app.status}
                        </span>
                        <br />
                        <strong>Notes:</strong> {app.notes}
                        <br />
                        <strong>Appointment Links:</strong>{' '}
                        {app.appointment_links ? (
                          <span
                            dangerouslySetInnerHTML={{
                              __html: app.appointment_links
                            }}
                          />
                        ) : (
                          <span style={{ color: '#888', fontStyle: 'italic' }}>No link available</span>
                        )}
                      </div>
                    </li>
                  ))}
              </ul>
              <div style={styles.moreLinkRow}>
                <button
                  style={styles.moreLink}
                  onClick={() => navigate('/appointments')}
                >
                  All Appointments
                </button>
              </div>
            </>
          )}
        </div>
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>My Ratings</h3>
          {ratings.length === 0 ? (
            <div style={styles.empty}>No ratings yet.</div>
          ) : (
            <ul style={styles.list}>
              {ratings.map(rating => (
                <li key={rating.id} style={styles.listItem}>
                  <div>
                    {vendorNames[rating.vendor_id] || 'Loading...'}
                    <br />
                    <span style={styles.stars}>
                      {'★'.repeat(rating.rating)}
                      {'☆'.repeat(5 - rating.rating)}
                    </span>
                    <span style={{ marginLeft: '8px', fontWeight: 'bold', color: '#8d6e36' }}>
                      {rating.rating}/5
                    </span>
                    <br />
                    <strong>Comment:</strong> 
                    <span style={styles.ratingComment}> {rating.comment || 'No comment provided'}</span>
                    <br />
                    <strong>Date:</strong> 
                    <span style={{ color: '#666', fontSize: '0.9rem' }}>
                      {' '}
                      {rating.created_at
                        ? (() => {
                            const d = new Date(rating.created_at);
                            const mm = String(d.getMonth() + 1).padStart(2, '0');
                            const dd = String(d.getDate()).padStart(2, '0');
                            const yyyy = d.getFullYear();
                            return `${mm}/${dd}/${yyyy}`;
                          })()
                        : ''}
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>Invoices</h3>
          {appointments.filter(app => app.status === 'completed' || app.status === 'accepted').length === 0 ? (
            <div style={styles.empty}>No invoices found.</div>
          ) : (
            <>
              <ul style={styles.list}>
                {appointments
                  .filter(app => app.status === 'completed' || app.status === 'accepted') // Filter out pending appointments
                  .sort((a, b) => new Date(b.creation_date) - new Date(a.creation_date))
                  .slice(0, 5)
                  .map(app => {
                    // Parse time with AM/PM support
                    const parseTime = (timeStr) => {
                      if (!timeStr) return null;
                      const match = timeStr.match(/^(\d{1,2}):(\d{2})\s*([AP]M)?$/i);
                      if (!match) return null;
                      let hour = parseInt(match[1], 10);
                      const minute = parseInt(match[2], 10);
                      const ampm = match[3] ? match[3].toUpperCase() : null;
                      if (ampm === 'PM' && hour < 12) hour += 12;
                      if (ampm === 'AM' && hour === 12) hour = 0;
                      return hour * 60 + minute;
                    };
                    const getHours = (start, end) => {
                      const startMinutes = parseTime(start);
                      const endMinutes = parseTime(end);
                      if (startMinutes === null || endMinutes === null) return 0;
                      let diff = endMinutes - startMinutes;
                      return diff > 0 ? (diff / 60) : 0;
                    };
                    const hours = getHours(app.start_time, app.end_time);
                    const rate = app.hourly_rate || 15;
                    const serviceTotal = (hours * rate).toFixed(2);
                    const bookingFee = (serviceTotal * 0.10).toFixed(2);
                    const total = (Number(serviceTotal) + Number(bookingFee)).toFixed(2);
                    const vendorName = vendorNames[app.vendor_id] || 'Loading...';
                    return (
                      <li key={app.id} style={styles.listItem}>
                        <div>
                         
                          <strong>Vendor:</strong> {vendorName}
                          <br />
                          <strong>Date:</strong>{' '}
                          {app.date
                            ? (() => {
                                const d = new Date(app.date);
                                const mm = String(d.getMonth() + 1).padStart(2, '0');
                                const dd = String(d.getDate()).padStart(2, '0');
                                const yyyy = d.getFullYear();
                                return `${mm}/${dd}/${yyyy}`;
                              })()
                            : ''}
                          <br />
                          <strong>Hourly Rate:</strong> ${rate}
                          <br />
                          <strong>Hours:</strong> {hours}
                          <br />
                          <strong>Service Total:</strong> ${serviceTotal}
                          <br />
                          <strong>Booking Fee (10%):</strong> ${bookingFee}
                          <br />
                          <strong>Total:</strong> ${total}
                          <br />
                          <strong>Work Status:</strong>{' '}
                          <span
                            style={{
                              color:
                                app.status === 'pending'
                                  ? '#ff9800'
                                  : app.status === 'accepted'
                                  ? '#388e3c'
                                  : app.status === 'rejected'
                                  ? '#d32f2f'
                                  : '#333',
                              fontWeight: 'bold',
                            }}
                          >
                            {app.status}
                          </span>
                          <br />
                           <strong>Payment status:</strong>{' '}
                             <span
                            style={{
                              color:
                                app.paid_status === 'Pending'
                                  ? '#ff9800'
                                  : app.paid_status === 'Paid'
                                  ? '#388e3c'
                                  : app.paid_status === 'UnPaid'
                                  ? '#d32f2f'
                                  : '#333',
                              fontWeight: 'bold',
                            }}
                          >
                            {app.paid_status}
                          </span>
                        </div>
                      </li>
                    );
                  })}
              </ul>
              <div style={styles.moreLinkRow}>
                <button
                  style={styles.moreLink}
                  onClick={() => navigate('/invoices')}
                >
                  All Invoices
                </button>
              </div>
            </>
          )}
        </div>
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>Search for Services</h3>
          <div style={styles.searchBox}>
            <button
              style={styles.searchBtn}
              onClick={() => navigate('/search')}
            >
              <i className="fas fa-search" style={{ marginRight: '8px' }}></i>
              Search Services
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '1100px',
    margin: '40px auto',
    padding: '32px',
    background: '#fff',
    borderRadius: '18px',
    boxShadow: '0 6px 32px rgba(141,110,54,0.10)',
  },
  title: {
    marginBottom: '38px',
    color: '#4078c0',
    fontSize: '2.2rem',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '1.5px',
    fontFamily: 'Segoe UI, Arial, sans-serif',
  },
  cardGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '36px',
  },
  card: {
    background: '#f5f6fa',
    borderRadius: '14px',
    boxShadow: '0 1px 8px #e0cfa0',
    padding: '28px 22px 22px 22px',
    minHeight: '220px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    border: '2px solid #e0cfa0',
    transition: 'box-shadow 0.2s, border 0.2s, background 0.2s',
    position: 'relative',
  },
  cardTitle: {
    marginBottom: '18px',
    color: '#8d6e36',
    fontSize: '1.18rem',
    fontWeight: 'bold',
    letterSpacing: '0.5px',
    fontFamily: 'Segoe UI, Arial, sans-serif',
  },
  empty: {
    color: '#888',
    fontSize: '1.08rem',
    textAlign: 'center',
    marginTop: '24px',
    fontStyle: 'italic',
  },
  list: {
    paddingLeft: '0',
    fontSize: '1rem',
    color: '#333',
    listStyle: 'none',
    margin: 0,
  },
  listItem: {
    marginBottom: '18px',
    padding: '14px 14px 10px 14px',
    borderRadius: '10px',
    boxShadow: '0 1px 4px #e0cfa0',
    fontFamily: 'Segoe UI, Arial, sans-serif',
    background: '#fff',
    position: 'relative',
  },
  stars: {
    color: '#FFD700',
    fontWeight: 'bold',
    fontSize: '1.1rem',
    letterSpacing: '2px',
    marginRight: '8px',
  },
  ratingComment: {
    color: '#333',
    fontSize: '1rem',
    fontStyle: 'italic',
  },
  searchBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '18px',
  },
  searchBtn: {
    background: '#4078c0',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '10px 28px',
    fontSize: '1.08rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #e0cfa0',
    transition: 'background 0.2s',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
  },
  moreLinkRow: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '12px',
  },
  moreLink: {
    background: '#4078c0',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '8px 22px',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #e0cfa0',
    transition: 'background 0.2s',
    textDecoration: 'none',
  },
};

export default CustomerDashboard;